// extracted by mini-css-extract-plugin
export default {"main":"CatalogSliderCard_main__tncX+"};